/* <copyright file="main.js" company="Rosemount Tank Radar AB">
  Copyright (c) Rosemount Tank Radar AB,  Sweden,  2017.
  This document is proprietary information of Rosemount Tank Radar and must
  not be given to a third party prior to the written authorization of
  Rosemount Tank Radar.
</copyright> */
import('@/setupServices'); // eslint-disable-line
